(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-gift-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    }
    function refreshCartUI(cart) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count')
        .forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('free-gift:added', { detail: cart }));
    }
    function setup(root) {
      if (root.__fgInit) return;
      root.__fgInit = true;

      var giftLabel = root.getAttribute('data-fg-gift') || 'Free gift';
      var radios = root.querySelectorAll('input[name="free-gift-choice"]');
      var btn = root.querySelector('[data-free-gift-add]');
      var status = root.querySelector('[data-free-gift-status]');

      var giftIds = Array.prototype.map.call(radios, function (r) { return parseInt(r.value, 10); });
      var selected = null;

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          selected = { id: parseInt(r.value, 10), title: r.dataset.title };
          btn.disabled = false;
          status.textContent = '';
        });
      });

      btn.addEventListener('click', async function () {
        if (!selected) return;
        btn.disabled = true;
        status.textContent = 'Adding…';
        try {
          var cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();

          var toRemove = cart.items.filter(function (it) {
            return giftIds.indexOf(it.variant_id) !== -1 && it.variant_id !== selected.id;
          });
          for (var i = 0; i < toRemove.length; i++) {
            await post('/cart/change.js', { id: toRemove[i].key, quantity: 0 });
          }

          var existing = cart.items.find(function (it) { return it.variant_id === selected.id; });
          if (existing) {
            if (existing.quantity !== 1) {
              await post('/cart/change.js', { id: existing.key, quantity: 1 });
            }
          } else {
            var res = await post('/cart/add.js', {
              items: [{ id: selected.id, quantity: 1, properties: { '_free_gift': giftLabel } }]
            });
            if (!res.ok) {
              var err = await res.json().catch(function () { return {}; });
              throw new Error(err.description || 'Could not add the gift.');
            }
          }

          var freshCart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
          refreshCartUI(freshCart);

          var qualifies = freshCart.items.some(function (it) {
            return giftIds.indexOf(it.variant_id) === -1;
          });
          status.innerHTML = qualifies
            ? 'Added — ' + selected.title + ' is free at checkout. <a href="/cart">View cart</a>'
            : 'Added — ' + selected.title + '. Add any item to unlock it free. <a href="/cart">View cart</a>';
          btn.disabled = false;
        } catch (e) {
          status.textContent = (e && e.message) ? e.message : 'Something went wrong. Please try again.';
          btn.disabled = false;
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-free-gift]').forEach(setup);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
